import { normalize } from 'normalizr'
import request from '../../services/request'
import { activityListResponseSchema } from './model'

const activities = {
  async getAll() {
    const result = await request('/sectorial/data/activities')

    return normalize(result, activityListResponseSchema)
  },
  async getByCode(code) {
    const result = await request(`/sectorial/data/activities/${code}`)

    return result.response
  }
}

export default activities
